var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBusinessDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.58,
    height: 44.851,
    viewBox: "0 0 44.58 44.851",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27304",
    "data-name": "Group 27304",
    transform: "translate(-20.281 -20.892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4715",
    "data-name": "Group 4715",
    transform: "translate(21.231 21.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24319",
    "data-name": "Path 24319",
    d: "M44.1,32.146A12.719,12.719,0,1,0,56.809,44.859,12.714,12.714,0,0,0,44.1,32.146Z",
    transform: "translate(-22.756 -23.389)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24320",
    "data-name": "Path 24320",
    d: "M45.534,21.842h0A4.629,4.629,0,0,0,52.8,24.2h0l4.795,3.483h0a4.628,4.628,0,0,0,4.489,6.177h0L63.912,39.5h0a4.627,4.627,0,0,0,0,7.636h0l-1.831,5.637h0a4.628,4.628,0,0,0-4.489,6.177h0L52.8,62.434h0a4.628,4.628,0,0,0-7.263,2.359H39.608a4.627,4.627,0,0,0-7.262-2.359h0L27.551,58.95h0a4.628,4.628,0,0,0-4.489-6.177h0l-1.831-5.637h0a4.628,4.628,0,0,0,0-7.636h0l1.831-5.637h0a4.628,4.628,0,0,0,4.489-6.177h0L32.346,24.2h0a4.628,4.628,0,0,0,7.262-2.36h5.927Z",
    transform: "translate(-21.231 -21.842)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4716",
    "data-name": "Group 4716",
    transform: "translate(33.656 34.287)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24321",
    "data-name": "Path 24321",
    d: "M35.852,56.267A8.921,8.921,0,0,1,44.764,47.7a8.92,8.92,0,0,1,8.912,8.577",
    transform: "translate(-35.852 -38.171)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_635",
    "data-name": "Ellipse 635",
    cx: 3.833,
    cy: 3.833,
    r: 3.833,
    transform: "translate(5.081 0)",
    fill: "none",
    stroke: "#7bd2b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.9
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusinessDetails);
export default __webpack_public_path__ + "static/media/Icon_businessDetails.d2334e387b2945ffc82319da7e06b29d.svg";
export { ForwardRef as ReactComponent };